import { render, staticRenderFns } from "./annualbudget.vue?vue&type=template&id=05b8fc0a"
import script from "./annualbudget.vue?vue&type=script&lang=js"
export * from "./annualbudget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports